import React from 'react'
import { BatchProcessProvider, DetailStoreProvider } from '@vt/hooks'
import BatchProcess from '../../../batch-process'

const Review = function () {
  return (
    <BatchProcessProvider>
      <div className="flex flex-row">
        <DetailStoreProvider>
          <BatchProcess />
        </DetailStoreProvider>
      </div>
    </BatchProcessProvider>
  )
}

export default Review
